module.exports = __webpack_public_path__ + "img/caretArrowUp_w.18abc089.svg";